import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimerDefault = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 19,
	viewBox: "0 0 16 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.41667 0.75V4.08333M7.41667 4.08333C3.73477 4.08333 0.75 7.0681 0.75 10.75C0.75 14.4319 3.73477 17.4167 7.41667 17.4167C11.0986 17.4167 14.0833 14.4319 14.0833 10.75C14.0833 7.0681 11.0986 4.08333 7.41667 4.08333ZM5.75 0.75H9.08333M13.5552 3.51815L14.4391 4.40203M9.615 8.33341L7.25798 10.6904M9.62639 8.33199L7.26937 10.689",
		stroke: "#EA580C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTimerDefault);
export default ForwardRef;
